module.exports = __webpack_public_path__ + "img/tpc-37.1cbd1681.jpg";